/**
 * AppLauncherButton — Botão do header que abre o popover de atalhos
 *
 * Ícone 3x3 (LayoutGrid) inspirado no launcher do Gmail. Fica visível para
 * qualquer usuário autenticado; o conteúdo interno é filtrado por permissão.
 *
 * RELEASE: 2026-07-24 v1.1.0 - Visual premium: gradiente, borda, shadow, hover elevate.
 * RELEASE: 2026-07-24 v1.0.0 - Criação.
 */
import { useState } from 'react';
import { LayoutGrid } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { Button } from '@/components/ui/button';
import { AppLauncherPopover } from './AppLauncherPopover';

export function AppLauncherButton() {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <Tooltip>
        <TooltipTrigger asChild>
          <PopoverTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="h-9 w-9 rounded-xl border border-border/70 bg-gradient-to-br from-card to-muted/40 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-primary/40 hover:shadow-md hover:bg-gradient-to-br hover:from-card hover:to-muted/60 active:translate-y-0 active:shadow-sm focus-visible:ring-2 focus-visible:ring-primary/50"
              aria-label="Atalhos rápidos"
            >
              <LayoutGrid className="h-4 w-4 text-primary" />
            </Button>
          </PopoverTrigger>
        </TooltipTrigger>
        <TooltipContent side="bottom">Atalhos rápidos</TooltipContent>
      </Tooltip>
      {/* v1.1.0: max-h + overflow-hidden garantem que o popover jamais
          estoure a viewport e que o ScrollArea interno tenha altura definida. */}
      <PopoverContent
        align="end"
        sideOffset={8}
        className="w-auto max-h-[85vh] overflow-hidden rounded-2xl border-border/70 p-0 shadow-xl"
      >
        <AppLauncherPopover onClose={() => setOpen(false)} />
      </PopoverContent>
    </Popover>
  );
}
